exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wrapper {\n  height: 31px;\n  position: absolute;\n  width: 100%; }\n\n#wrapper-button {\n  height: 32px;\n  position: absolute;\n  right: 0;\n  width: 32px; }\n\n#wrapper-button > img {\n  height: 8px;\n  left: 9px;\n  position: absolute;\n  top: 16px;\n  width: 8px; }\n\n#wrapper-text {\n  color: #9c9c9c;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  height: 14px;\n  left: 14px;\n  position: absolute;\n  top: 14px;\n  width: calc(100% - 56px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/subPageHeader/subPageHeader.component.scss
// module id = 417
// module chunks = 1